import React, { FC, useState, useRef } from 'react';
import { home } from 'texts/texts';
import { Button } from 'components/button/Button';
import { TextWithStyle } from 'components/TextWithStyle';
import './BottomSection.css';
import { GetToastieDialog } from 'components/get-toastie-dialog/get-toastie-dialog';
import { motion, useInView } from "framer-motion";

interface NavbarProps { }

export const BottomSection: FC<NavbarProps> = () => {  
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  
  // const logoSrc = `${process.env.PUBLIC_URL}/assets/toastie-logo.png`;
  const infoSrc = `${process.env.PUBLIC_URL}/assets/user-shield-icon.png`;

  const handleWaitlistClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <div className="bottom-section">
      <div className="home-content-container"
        // style={{ background: 'linear-gradient(to bottom, #fff 20%, var(--primary100) 80%)' }}
      >
        <div className='container-vertical width-large'>
          <div className='container-vertical width-medium' id='slogan-div'>
            {/* <img className='img-small' src={logoSrc} alt='Toastie Logo' /> */}
            <div className="eyebrow">
              <span className="eyebrow-dot"></span>
                Get started now
            </div>
            <h2 className="title-xl">
              {home.slogan.map((part, index) => (
                <TextWithStyle key={index} text={part.text} style={part.style} />
              ))}
            </h2>
            <GetToastieDialog
              isOpen={isDialogOpen}
              onClose={handleCloseDialog}
            />
            <Button label={home.buttonText} onClick={handleWaitlistClick} />
          </div>
        </div>
        <motion.div
          ref={ref}
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration : 1 }}
          id='info-container' className='container-horizontal margin-large border-radius-medium'>
            <img className='img-small' src={infoSrc} alt='User Shield Icon' />
            <div className='privacy-text'>
              <h3>Your Privacy Matters</h3>
              <p>We built Toastie with privacy at the core. Your data stays <strong>secure and encrypted</strong>, and we'll never sell your information.</p>
              <div className="checklist">
                <p>✅ No third-party tracking  </p>
                <p>✅ You control what's shared  </p>
                <p>✅ End-to-end encryption  </p>
              </div>
            </div>
        </motion.div>
      </div>
    </div>
  )
};
